import React from 'react';
import { useAPIContext } from '../../context/api';
import { AudioAPI } from '../../../../constructs/audio/interface';

/**
 * Llama al endpoint `GET /audio/music`. Devuelve la lista de tracks del cliente
 * autenticado, o null si falla. Tracks se cargan desde DDB (no hardcoded).
 */
export const useListMusicTracks = () => {
  const { callEndpoint } = useAPIContext();

  const listMusicTracks = React.useCallback(async () => {
    try {
      const res = await callEndpoint<AudioAPI, 'music-tracks'>('audio', '/music', 'GET');
      if (!res) throw new Error('Respuesta del servidor inesperada');
      return res;
    } catch (error: any) {
      console.error('Error al listar music tracks:', error);
      return null;
    }
  }, [callEndpoint]);

  return { listMusicTracks };
};
